import { memo } from 'react';
import dayjs from 'dayjs';

import { HeaderType } from '@utils/types';
import { getSystemLogType } from '@lib/enum';
import { AdminLog } from '@graphql/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';

type SystemLogTableRowProps = {
    headers: HeaderType[];
    data: AdminLog;
};

const SystemLogTableRow = ({ headers = [], data }: SystemLogTableRowProps) => {
    return (
        <TableRow $default>
            <TableCell
                $minWidth={headers[0].minWidth}
                $width={headers[0].width}
            >
                {data?.createdAt
                    ? dayjs(data.createdAt).format('YYYY-MM-DD HH:mm')
                    : '-'}
            </TableCell>
            <TableCell
                $minWidth={headers[1].minWidth}
                $width={headers[1].width}
            >
                {data?.type ? getSystemLogType(data?.type) : '-'}
            </TableCell>
            <TableCell
                $minWidth={headers[2].minWidth}
                $width={headers[2].width}
            >
                {data?.name ? `${data?.name} ${data?.rank}` : '-'}
            </TableCell>
            <TableCell
                $minWidth={headers[3].minWidth}
                $width={headers[3].width}
            >
                {data?.text || '-'}
            </TableCell>
        </TableRow>
    );
};

export default memo(SystemLogTableRow);
